import React, { useEffect, useMemo, useState } from 'react';
import { createStore, Provider } from 'jotai';
import EmailSubscriptionsDrawer from './EmailSubscriptionsDrawer';
import apptracker from '@src/utils/sensor/apptracker';
import { OPEN_EMAIL_SUBSCRIPTIONS_DRAWER } from '@src/utils/sensor/track';
import { CURRENT_PRODUCT_MODE } from '@src/utils/constants';

export const OPEN_EMAIL_SUBSCRIPTIONS_EVENT = 'open-email-subscriptions';

const EmailSubscriptionsPage = () => {
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const store = useMemo(() => {
    return createStore();
  }, []);

  useEffect(() => {
    const handleOpenPage = () => {
      apptracker(OPEN_EMAIL_SUBSCRIPTIONS_DRAWER, { product: CURRENT_PRODUCT_MODE });
      setOpenDrawer(true);
    };
    window.addEventListener(OPEN_EMAIL_SUBSCRIPTIONS_EVENT, handleOpenPage);
    return () => {
      window.removeEventListener(OPEN_EMAIL_SUBSCRIPTIONS_EVENT, handleOpenPage);
    };
  }, []);

  return (
    <div data-ifc-event={OPEN_EMAIL_SUBSCRIPTIONS_EVENT}>
      <Provider store={store}>
        {openDrawer ? (
          <EmailSubscriptionsDrawer isOpen={openDrawer} closeDrawer={handleCloseDrawer} />
        ) : null}
      </Provider>
    </div>
  );
};

export default EmailSubscriptionsPage;
